var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNextPaginate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1L3.5 2.70435L6 4.4087L1 8",
    stroke: "#616161",
    strokeOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4 1L6.5 2.70435L9 4.4087L4 8",
    stroke: "#616161",
    strokeOpacity: 0.7
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextPaginate);
export default __webpack_public_path__ + "static/media/next-paginate.d77beae3b94624dfaa9e967c1b71c074.svg";
export { ForwardRef as ReactComponent };